import { Image } from '@app/components'
import React from 'react'
import { CSSProperties } from 'styled-components'

export const EthereumIcon = ({ style }: { style?: CSSProperties }) => {
  const size = Number.parseInt(String(style?.height ?? style?.width ?? 24), 10) || 24
  return (
    <Image
      preview={false}
      src="../images/ethereum.png"
      width={size}
      height={size}
      style={{ objectFit: 'contain', ...style, width: size, height: size }}
    />
  )
}
